import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TextKeys } from '../../../../core/i18n/text-keys';
import { Observable, Subject, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { EventIndexModel } from '../../../../core/models/event-index.model';
import { tap } from 'rxjs/operators';
import { MaterialColumnsEnum } from '../../../../core/state-mangement/entities/material-items/material-columns.enum';
import {Sort} from "@angular/material/sort";
import { MaterialModel } from '../../../../core/models/material/material-model';

@Component({
  selector: 'app-material-list-table',
  templateUrl: './material-list-table.component.html',
  styleUrls: ['./material-list-table.component.scss'],
})
export class MaterialListTableComponent implements OnInit {
  @Input() materialList$: Observable<MaterialModel[]>;
  @Input() tableColumns$: Observable<any>;
  @Input() selectedIndex$: Observable<number>;
  @Output() onClickEvent = new EventEmitter<number>();
  @Output() sortEvent = new EventEmitter<Sort>();
  @Output() doubleClickEvent = new EventEmitter<void>();

  dataSource: MatTableDataSource<MaterialModel>;
  onResize$ = new Subject<EventIndexModel>();
  columns = MaterialColumnsEnum;
  displayedColumns: string[] = [];

  private subscriptions = new Subscription();

  constructor() {}

  ngOnInit() {
    this.subscriptions.add(
      this.materialList$.subscribe((value) => {
        this.dataSource = new MatTableDataSource<MaterialModel>(value);
      })
    );
    this.registerColumns();
  }

  onColumnResize(event, column) {
    const index = this.displayedColumns.findIndex(
      (element) => element == column
    );
    this.onResize$.next({
      event,
      index,
    } as EventIndexModel);
  }

  onClick(row: number) {
    this.onClickEvent.next(row);
  }

  onDoubleClick() {
    this.doubleClickEvent.emit();
  }

  onSort(event: Sort) {
    this.sortEvent.emit(event);
  }

  private registerColumns() {
    this.subscriptions.add(
      this.tableColumns$
        .pipe(
          tap((columns) => {
            this.displayedColumns = [];
            columns.forEach((column) => {
              if (column.selected) {
                this.displayedColumns.push(column.name);
              }
            });
          })
        )
        .subscribe()
    );
  }
}
